<div class="corporate-loans-contract-component">
  <mat-card appearance="outlined">
    <mat-card>
      <asset-notes
        [isAssetUpdated]="isAssetUpdated"
        [getApplicationAuditLogsFn]="getApplicationAuditLogsFn"
        [getNotesByApplicationIdFn]="getNotesByApplicationIdFn"
        [createApplicationNoteFn]="createApplicationNoteFn"
        [removeApplicationNoteByNoteIdFn]="removeApplicationNoteByNoteIdFn"
      ></asset-notes>
    </mat-card>
  </mat-card>
</div>
